import React, { useState, useCallback, ReactElement } from 'react';
import * as css from './MfgInquiry.module.scss';
import 'src/css/themes.scss';
import { IconSeeMore } from 'src/content/icons';
import { ConnectedVehicleRec, MFGINQ } from 'src/models';
import { Dialog, ScrollBar } from '@framework-controls/core';
import { strings } from 'src/localization';

export interface IProps {
    connectedVehicle: ConnectedVehicleRec;
    displayMfgInquiry: () => void;
}

const MfgInquiry = (props: IProps) => {
    const [mfgOpen, setMfgOpen] = useState(false);
    const toggleMfg = useCallback(() => {
        setMfgOpen(!mfgOpen);
    }, [mfgOpen]);

    const displayInquiry = useCallback(() => {
        props.displayMfgInquiry();
    }, [props.displayMfgInquiry]);

    let mfgInq: ReactElement[] | null = null;
    if (props.connectedVehicle.mfgInq && props.connectedVehicle.mfgInq.length > 0) {
        const indexedMfg: MFGINQ[] = [];
        props.connectedVehicle.mfgInq.forEach((mfg, index) => {
            let adjustedLine = mfg.line;
            if (mfg.line === '') {
                adjustedLine = ' ';
            }
            indexedMfg.push(
                {
                    index: index + 1,
                    line: adjustedLine,
                },
            );
        });
        mfgInq = indexedMfg.map(mfg => <span className={css.mfgRow}
            id={mfg.index.toString()}
            key={mfg.index}>
            <div className={css.mfgLine}>{mfg.line}</div>
        </span>);
    }

    let mfgArea: ReactElement | null = null;
    if (props.connectedVehicle.mfgInq && props.connectedVehicle.mfgInq.length > 0) {
        mfgArea = <div>
            <ScrollBar scrollVertical>
                <span>
                    {mfgInq}
                </span>
            </ScrollBar>
        </div>;
    }

    let mfgIcon: ReactElement | null = null;
    if ((props.connectedVehicle.parentMake === 'TY') || (props.connectedVehicle.parentMake === 'LX')) {
        mfgIcon = <IconSeeMore onClick={() => displayInquiry()} />;
    } else {
        mfgIcon = <IconSeeMore onClick={() => toggleMfg()} />;
    }

    return (
        <div>
            <span className={css.header}>
                <div className={css.headerLit}>{strings.ViewManufacturerInquiry}</div>
                <div className={css.icon}>
                    {mfgIcon}
                </div>
            </span>
            <Dialog
                cssClasses={{
                    content: css.content,
                    paper: css.paper,
                    header: css.LightBoxHeader,
                }}
                isOpen={mfgOpen}
                anchorOrigin={{
                    vertical: 'top',
                }}
                header={strings.ManufacturerInquiry}
                hideSave={true}
                hideCancel={true}
                disableUpperCase={true}
                onCancel={() => toggleMfg()}
                onBackDropClick={() => toggleMfg()}
                width={'full'}
            >
                {mfgArea}
            </Dialog>
        </div>
    );
};

export default MfgInquiry;